module.exports = __webpack_public_path__ + "img/bg.b641a18.jpg";